import React, { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet, View } from 'react-native';
import { useSetRecoilState } from 'recoil';

import { alertsTestIDs, Theme } from '@constants';
import { helpers } from '@helpers';
import { useContextNodeHandle } from '@hooks';
import { navigationService } from '@services';
import { hdmiConnectedState } from '@store';

import { TWCButton } from '../../focusable/TWCButton/TWCButton';
import { TWCTileContent } from '../../focusable/TWCTileContent/TWCTileContent';
import { TWCText } from '../../primitives/TWCText/TWCText';

const tPath = 'alerts.disconnected';

export const AlertDisconnected: FC = () => {
  const { t } = useTranslation('translation', { keyPrefix: tPath });

  const okButtonHandle = useContextNodeHandle(alertsTestIDs.disconnected.okButton);

  const setHDMIConnected = useSetRecoilState(hdmiConnectedState);

  useEffect(() => {
    if (helpers.isWeb) {
      setTimeout(() => {
        helpers.FOCUS_NOW(okButtonHandle);
      }, 10);
    }
  }, [okButtonHandle]);

  return (
    <TWCTileContent height={615} width={674}>
      <View style={styles.alertModalContent}>
        <TWCText style={styles.titleText} testID={alertsTestIDs.disconnected.headlineText} variant={'regularText36'}>
          {t('headingText')}
        </TWCText>
        <TWCText
          style={styles.detailText}
          testID={alertsTestIDs.disconnected.detailText}
          variant={'regularText36Transparent'}
        >
          {t('detailText')}
        </TWCText>
        <TWCButton
          accessibilityHint={t('okButtonAccessibilityHint')}
          accessibilityLabel={t('okButtonAccessibilityLabel')}
          nextFocusDown={null}
          nextFocusLeft={null}
          nextFocusRight={null}
          nextFocusUp={null}
          testID={alertsTestIDs.disconnected.okButton}
          title={t('okButtonText')}
          onPress={() => {
            setHDMIConnected(true);
            navigationService.goBack();
          }}
        />
      </View>
    </TWCTileContent>
  );
};

const styles = StyleSheet.create({
  alertModalContent: {
    alignItems: 'center',
    flex: 1,
    justifyContent: 'center',
  },
  detailText: {
    lineHeight: Theme.px(48),
    paddingVertical: Theme.px(46),
    textAlign: 'center',
  },
  titleText: {
    lineHeight: Theme.px(48),
    paddingHorizontal: Theme.px(60),
    textAlign: 'center',
  },
});
